module.exports = {
  "Accessory Lost": "车辆附件丢失罚款",
  "Additional Charges": "额外收费",
  "Additional Driver Fee": "附加驾驶人费",
  "Administration Fee": "行政费用",
  Payment: "支付",
  Cleaning: "清洁费",
  "Damage Repair": "车辆损坏维修费",
  "Delay fee": "超时费",
  "Delay Return": "延期还车费",
  "Delivery Fee": "上门接送车费",
  "Extra mileage": "额外里程",
  "Extras Service": "额外服务费",
  Fuel: "燃油费",
  "One Way Fee": "异地还车费",
  "Online Booking": "在线预订",
  "Renewal Extras Service": "续租额外服务费",
  "Renewal Rental Of Vehicle": "续租车辆租金",
  "Roadside Assistance": "道路救援费",
  "Security deposit paid": "已付押金",
  "Security deposit returned": "已退还押金",
  "Traffic Violations": "交通违规罚款",
  "Young Driver Fee": "年轻驾驶员费",
  "Vehicle Rental Fee": "车辆租金",
  "Prepaid Deposit": "预付定金",
  "Insurances Fee": "保险费",
  "Renewal Insurances Fee": "续租保险费",
  "Vehicle Deposit": "车辆押金",
  "Replace Vehicle Fee": "更换车辆费用",
  "Hourly Fee": "零散小时费",
  "Extend Hourly Fee": "续租零散小时费",

  "Damage Fee": "车损费",
  "Late Fee": "超时费",
  "Late Return": "延期还车费",
  "Delivery/Collection Fee": "上门接送车费",
  "Extra Mileage": "额外里程",
  "Optional Service Fee": "额外服务费",
  "Extend Optional Service": "续租额外服务费",
  "Extend Rental": "续租车辆租金",
  "Extend Insurances Fee": "续租保险费",
  "Extend Young Driver Fee": "续租年轻驾驶人费",

  "Zuzuche Insurance Renew Fee": "租租车保险续租费用",

  "Order Cancel Fee": "订单取消费",

  "The Optional Service Prepaid And Not In Package": "预付非套餐额外服务",

  "Infringement Nomination Fee": "罚单转名费",
  "Toll Way Fee": "收费路段费用",
  "Toll Way Admin Fee": "收费路段注册费",
  "C-Card Fee": "信用卡手续费",
  "Extra Damage Charge": "附加维修费",

  "Processing Fee of Traffic Ticket": "交通违规罚款手续费",
  "Processing Fee of Highway Charges": "收费路段费用手续费",
  "Processing Fee of Additional Service": "额外收费手续费",

  "Loss of Use": "停运费",
  "Infringement deposit": "违章押金",
};
